export const stripBase = (signature: string) => {
  return signature.replace('data:image/png;base64,', '')
}
